import { validateMapDecorTemplate } from "./mapDecor.js";

export function createMapDecorMap(template, input = {}) {
  const errors = validateMapDecorMapInput(input);
  if (errors.length) throw new Error(errors[0]);
  const field = (template.fields || []).find((item) => item.role === "mapDecorMap");
  if (!field) throw new Error("Kartmalen mangler kartfelt.");
  const option = {
    value: uniqueValue(input.name, field.options || []), label: String(input.name).trim(),
    category: String(input.category || "Andre").trim() || "Andre", description: String(input.description || "").trim(),
    thumbnailUrl: input.thumbnailUrl || input.previewUrl, imageUrl: input.previewUrl,
    productionAssetUrl: input.productionAssetUrl, sourceName: String(input.sourceName).trim(),
    sourceUrl: String(input.sourceUrl).trim(), sourceVersion: String(input.sourceVersion).trim(),
    labelsLanguage: String(input.labelsLanguage || "nb-NO"), commercialRightsConfirmed: true,
    geographyValidated: true, geographyValidatedAt: String(input.geographyValidatedAt).trim(),
    rightsNote: String(input.rightsNote || "Rettigheter bekreftet av administrator.").trim(), uploaded: true,
  };
  field.options ||= [];
  field.options.push(option);
  template.draftUpdatedAt = new Date().toISOString();
  return option;
}

export function validateMapDecorMapInput(input = {}) {
  const errors = [];
  if (!String(input.name || "").trim()) errors.push("Kartnavn må fylles ut.");
  if (!input.previewUrl) errors.push("Forhåndsvisning må lastes opp.");
  if (!String(input.productionAssetUrl || "").toLowerCase().endsWith(".svg")) errors.push("Produksjonsfilen må være en SVG.");
  if (!String(input.sourceName || "").trim() || !String(input.sourceUrl || "").trim() || !String(input.sourceVersion || "").trim()) errors.push("Kartgrunnlag, kilde-URL og versjon må dokumenteres.");
  if (input.commercialRightsConfirmed !== true) errors.push("Kommersielle rettigheter må bekreftes.");
  if (input.geographyValidated !== true || !String(input.geographyValidatedAt || "").trim()) errors.push("Geografien må være kontrollert og datert.");
  return errors;
}

export function validateMapDecorForPublication(template) { return validateMapDecorTemplate(template); }

function uniqueValue(name, options) {
  const base = String(name).normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "kart";
  const existing = new Set(options.map((item) => item.value));
  if (!existing.has(base)) return base;
  let index = 2; while (existing.has(`${base}-${index}`)) index += 1;
  return `${base}-${index}`;
}
